// extracted by mini-css-extract-plugin
export default {"mainContainer":"Table_mainContainer__80AnB","tableContainer":"Table_tableContainer__5g5Gt","avatarCell":"Table_avatarCell__vfusB","statusCell":"Table_statusCell__QLZFB"};